// src/services/rightsApi.js — the browser's calls to the rights routes.
//
// The rules (what a notice needs, who may dispute) are services/contentRights,
// generated from the phone's TypeScript; the routes are
// server/functions/copyrightNotices.js. This file only carries the request.
import { auth } from '../config/firebase';
import { BACKEND_URL } from './socket';

async function post(path, body) {
  const u = auth.currentUser;
  if (!u) throw new Error('signed out');
  const res = await fetch(`${BACKEND_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${await u.getIdToken()}` },
    body: JSON.stringify(body),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || j?.ok === false) {
    const e = new Error(j?.error || `http ${res.status}`);
    e.code = j?.error; e.missing = j?.missing;
    throw e;
  }
  return j;
}

/** File a copyright notice about a post. Resolves { id, duplicate? }. */
export const fileNotice = (notice) => post('/api/rights/notice', notice);
/** The author disputes a mute. */
export const disputeMute = (postId, text = '') => post('/api/rights/dispute', { postId, text });
/** The author of a removed post counter-notices. */
export const fileCounterNotice = (counter) => post('/api/rights/counter-notice', counter);

/* ©️ PARITY WITH THE PHONE: the two server passes a post goes through after
   upload. The phone has always fired both; the browser fired neither, which
   meant a browser-posted image was never scanned for provenance and a
   browser-posted video waited for the ten-minute sweep. Fire-and-forget, like
   the phone — a failed trigger is caught by the sweeps. */
export function triggerTranscode(postId, videoPath) {
  if (!postId || !videoPath) return;
  fetch(`${BACKEND_URL}/api/transcode-video`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ postId, videoPath }),
  }).catch(() => {});
}
export function triggerOptimizeImage(postId, mediaId, storagePath) {
  if (!postId || !mediaId || !storagePath) return;
  fetch(`${BACKEND_URL}/api/optimize-image`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ postId, mediaId, storagePath }),
  }).catch(() => {});
}
